// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Expand: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path
                fill="currentColor"
                d="M.5 0h5a.5.5 0 0 1 0 1H1.706l5.147 5.147a.5.5 0 1 1-.707.707L1 1.707V5.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5v-5A.5.5 0 0 1 .5 0Zm9.353 9.147L15 14.294V10.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5h-5a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5h3.793L9.146 9.853a.5.5 0 1 1 .707-.706Z"
            />
        </svg>
    );
};

export default React.memo(Expand);
